<div class="campaign-title" *ngIf="title || subtitle">
  <div class="container">
    <h2 *ngIf="title">{{ title }}</h2>
    <p *ngIf="subtitle">{{ subtitle }}</p>
  </div>
</div>
